<template>
    <div id="billingReversingJournalEntry">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                 <div class="page-name">
                     <div class="page-title"> Billing Reversing Journal Entry Details</div>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backScreen" >
                          <i class="fp-back"> </i> Back
                  </button>
                  <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-1" v-on:click="exportCheck()">
                    <i class="fp-export"></i> Export
                  </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-list">
                        <section class="internal-container border-top-table-fl filters-container mb-4">
                            <div class="form-row">
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col">Year:</label>
                                        <span class="col label"> {{ headerDetails['year'] }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Period:</label>
                                        <span class="col label"> {{ headerDetails['period'] }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Batch:</label>
                                        <span class="col label"> {{ headerDetails['batch'] }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-row form-group">
                                        <label class="col"> Contract Billed Amount Total:</label>
                                        <span class="col label"> {{ headerDetails['contract_billed_amount_total'] }} </span>
                                    </div>
                                    <div class="form-row form-group">
                                        <label class="col"> Accrued Total:</label>
                                        <span class="col label"> {{ headerDetails['accrued_total'] }} </span>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <data-table-filter-config :moduleName="'billReversingJEDetailsList'" ref="billReversingJEDetailsList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                          batch no. is {{ batchNum }}.
                          <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                                      @click.native="batchProcess = 0"> Click Here
                          </router-link>
                          to check file status!
                        </p>
                        <p v-if="batchProcess1" class="alert-success p-2">{{deleteBillRevJEMsg}}</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'billReversingJEDetailsList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        ref="billingReversingJournalEntryDetailsList"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-select-all="onSelectAll"
                                        @on-selected-rows-change="selectionChanged"
                                        :totalRows="totalRecords"
                                        title="Billing Reversing Journal Entry Details List"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                        enabled: true,
                                }">
                                    <div slot="selected-row-actions">
                                          <button v-if="canDelete" id="deleteBillRevJEDetail" v-on:click.prevent="BillRevJEDetailsDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>


    import Vue from 'vue';






    import EventBus from ".././event-bus";


    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    let msgServer
    export default {
        name: "listCharge",
        metaInfo() {
            return {title: "Billing Reversing J/E Details | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({

            firstLoad : 0,
            userColumns:[],
            columns: [
                {
                    label: 'Cont Type',
                    field: 'cont_type',
                    html: true,
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Cont Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Unit',
                    field: 'unit',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Assigned',
                    field: 'assigned',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"date",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Assigned", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billed Date From',
                    field: 'bill_from_date',
                    hidden:false,
                    filterable: false,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Billed Date From", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Day','Week','Month','Mile','Fixed'],// dropdown (with selected values) instead of text input
                        // filterFn: this.onColumnFilter, //custom filter function that
                        // trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billed Date To',
                    field: 'bill_to_date',
                    hidden:false,
                    filterable: false,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Billed Date To", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Day','Week','Month','Mile','Fixed'],// dropdown (with selected values) instead of text input
                        // filterFn: this.onColumnFilter, //custom filter function that
                        // trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Section',
                    field: 'sect',
                    hidden:false,
                    filterable: true,
                    html: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sect", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Invoice',
                    field: 'invoice',
                    html: false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Invoice", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Total Days',
                    field: 'total_days',
                    html: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Total Days", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Total Amount',
                    field: 'total_amount',
                    html: false,
                    filterable: false,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Total Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Accrue Year',
                    field: 'accrue_year',
                    html: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Accrue Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Accrue Period',
                    field: 'accrue_period',
                    html: false,
                    filterable: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Accrue Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Accrue Days',
                    field: 'accrue_days',
                    html: false,
                    filterable: false,
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Accrue Days", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Accrue Amount',
                    field: 'accrue_amount',
                    html: false,
                    filterable: false,
                    fpFieldType:"integer",
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Accrue Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'G/L Account',
                    field: 'gl_account',
                    html: false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "G/L Account", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            headerDetails: [],
            totalRecords: 0,
            permissions:[],
            loading:false,
            action: "list",
            batchProcess: 0,
            batchNum: "",
            batchId:"",
            batchNum1: "",
            batchProcess1: 0,
            hidden:true,
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
            canDelete: false,
            deleteBillRevJEMsg:"",
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_bill_reversing_journal_entry_details') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'delete_bill_reversing_journal_entry_details') {
                        self.canDelete = true;
                    }
                });
                if(self.cantAccess == ''){
                    self.cantAccess = false;
                }
            }
        },
        created: function() {
            this.serverParams.sort = {field:"id",type:"desc"};
        },
        mounted: function () {
            this.getPermissions();

        },
        beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
            msgServer.close();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.billingReversingJournalEntryDetailsList.unselectAllInternal();
            },
            backScreen(){
                var self = this;
                var url = '/billing-reversing-journal-entry';
                self.redirectPageUrl(url);
            },
            checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            if (data.type != undefined && data.type == 'bill_rev_je_details_delete'){
                                self.deleteBillRevJEMsg = 'Billing reversing journal entries are deleted successfully';
                                setTimeout(function(){
                                    self.deleteBillRevJEMsg = '';
                                    self.batchProcess1 = false;
                                },4000);
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            if (data.type != undefined && data.type == 'bill_rev_je_details_delete'){
                                self.batchProcess1 = false;
                                self.deleteBillRevJEMsg = 'Billing reversing journal entries are not deleted.';
                            }else{
                                self.batchProcess1 = false;
                            }
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });
            },
            loadList: function(){
                var self = this;
                self.loading = true;
                self.firstLoad = 1;
                var path = window.location.pathname;
                var segments = path.split("/");
                var id = segments[2];
                var data = this.$refs['billingReversingJournalEntryDetailsList'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                  use.push(this.$refs['billingReversingJournalEntryDetailsList'].selectedRows[i].id)
                }

                self.filterAll = self.serverParams.columnFilters;
                if (self.action == "export") {
                  self.filterAll = self.removeOptionArr(self.serverParams.columnFilters);
                }
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    action:self.action,
                    idArr:use,
                    id:id
                };
                $.ajax({
                    url: process.env.ROOT_API + "/bill-reversing-journal-entry-details/list",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:fields,
                    success: function (data) {
                        self.loading = false;
                        if(data.status == 'success'){
                          if(self.action == 'list'){
                            if(data.content.row != undefined) {
                                self.rows = data.content.row;
                            }
                            if(data.content.totalRecords == 0){
                                self.rows = [];
                            }
                            self.headerDetails = data.content.header;
                            self.totalRecords = data.content.totalRecords;
                          } else {
                            if (self.action == "export" || self.action == "export_queue") {
                              if (data.code == "201") {
                                alert(data.message);
                              } else {
                                if (self.action == "export") {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);
                                } else {
                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                                }
                              }
                              self.action = "list";
                              self.loadList();
                            } else {
                              self.rows = data.content.row;
                              self.totalRecords = data.content.totalRecords;
                              self.filteredFlag = false;
                            }
                          }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            BillRevJEDetailsDelete: function(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Billing Reversing Journal Entry?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.DeleteBillRevJEDetails();
                    }
                });
            },

            DeleteBillRevJEDetails: function(){
                var self = this;
                var data = this.$refs['billingReversingJournalEntryDetailsList'].selectedRows;
                var idArr = [];
                for (var i = 0; i < data.length; i++) {
                    idArr.push(this.$refs['billingReversingJournalEntryDetailsList'].selectedRows[i].id);
                }
                var path = window.location.pathname;
                var segments = path.split("/");
                var id = segments[2];
                var fields ={
                    idArr : idArr,
                    all : self.serverParams.selectedAll,
                    billRevJEHeaderId : id,
                    filters: self.serverParams.columnFilters,
                };
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/bill-reversing-journal-entry-details/delete",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:fields,
                    success: function (data) {
                        self.loading = false;
                        if(data.status == 'success'){
                            self.$refs.billReversingJEDetailsList.clearSelectAll();

                            var msg = "";

                            if(data.deleted == 0){
                                data.deleted = "Selected";
                            }
                            msg = data.deleted+" records have been deleted";

                            msg +=".";

                            self.$swal('',msg,data.status);
                            EventBus.$emit('clear-all-flags', false);

                            if (data.batchId != undefined && data.batchId != ''){
                                self.batchId = data.batchId;
                                self.batchNum1 = data.batchNum;
                                self.batchProcess1 = true;
                                self.deleteBillRevJEMsg = 'Current batch '+ self.batchNum1+ ' for deleting billing-reversing-journal-entry is processing please wait!';
                                self.checkBatchStatus();
                            }

                            self.loadList();
                            return;
                        }

                        if(data.status == 'error'){
                            self.$swal('',data.message,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            exportCheck: function () {
              var self = this;
              var count = 0;
              var actionFlag = "";
              var data = this.$refs['billingReversingJournalEntryDetailsList'].selectedRows;
              count = data.length;

              if(this.serverParams.selectedAll == true){
                  actionFlag = "";
              }else if(count != 0 && count <= 100){
                  actionFlag = "export";
              }
              this.exportReports(actionFlag);
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/accounting/BillingReversingJEDetails.vue